import DateUtils from 'toolkit/DateUtils';

export const DEFAULT_MIN_DATE = new Date(DateUtils.subtractDaysFromStartToday(1));
export const DEFAULT_MAX_DATE = DateUtils.addDays(new Date(), 1);
